import React from "react";

function  UndoButton(props) {
    const buttonStyle = {
        opacity: "0.8",
        backgroundColor: "transparent", // Default background
        borderColor: "#dc3545", // Red border from btn-outline-danger
        color: "#dc3545", // Red text
        marginRight: "10px"
    };

    return (
        <button type="button" className="btn btn-outline-danger btn-sm photoEditorButton" style={buttonStyle} onClick={props.onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
                <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
            </svg>
        </button>
    );
}

export default UndoButton;